import { useCallback, useEffect, useState } from 'react';

export interface ImageFrame {
  width: number;
  height: number;
}

const EMPTY_IMAGE_FRAME: ImageFrame = {
  width: 0,
  height: 0,
};

const useImageFrame = (src?: string) => {
  const [imageFrame, setImageFrame] = useState<ImageFrame>(EMPTY_IMAGE_FRAME);

  useEffect(() => {
    setImageFrame(EMPTY_IMAGE_FRAME);
  }, [src]);

  const handleImageLoad = useCallback((event: React.SyntheticEvent<HTMLImageElement>) => {
    const { width, height } = event.currentTarget;
    setImageFrame({ width, height });
  }, []);

  return {
    imageFrame,
    hasMeasuredFrame: imageFrame.width > 0 && imageFrame.height > 0,
    handleImageLoad,
  };
};

export default useImageFrame;
